import applicationData, { appDataActions } from './applicationData';
import authentication, * as authenticationActions from './authentication/authentication.module';
import { autoExchangeReducer as autoExchange } from './autoExchange/reducer';
import * as autoExchangeActions from './autoExchange/actions';

import schools, * as addSchoolActions from './addSchool/addSchool.module';
import isDistributeToSchool, * as distributeToSchoolActions from './sellDeliveryMethod/distributeToSchool.module';
import schoolSelection, * as schoolSelectionActions from './schoolSelection/schoolSelection.module';
import studentDetail, * as studentDetailActions from './studentDetail/studentDetail.module';
import automaticEdit, * as automaticEditActions from './automaticEdit/automaticEdit.module';
import automaticInvestments, * as automaticActions from './automaticInvestments/automaticInvestments.module';
import bankSelection, * as bankSelectionActions from './bankSelection/bankSelection.module';
import bucketRoll, * as bucketRollActions from './bucketRoll/bucketRoll.module';
import chat, * as chatActions from './chat/chat.module';
import costBasis, * as costBasisActions from './costBasis/costBasis.module';
import editModeBank, * as editModeBankActions from './editModeBank/editModeBank.module';
import eVerification, * as eVerifyActions from './eVerification/eVerification.module';
import exchangeTransaction, * as exchangeTransactionActions from './exchangeTransaction/exchangeTransaction.module';
import executeAutoExchange, * as executeAutoExchangeActions from './executeAutoExchange/executeAutoExchange.module';
import executeCollegeContribute, * as executeCollegeContributeActions from './executeCollegeContribute/executeCollegeContribute.module';
import executeExchange, * as executeExchangeActions from './executeExchange/executeExchange.module';
import executePurchase, * as executePurchaseActions from './executePurchase/executePurchase.module';
import executeRecurringPurchase, * as executeRecurringPurchaseActions from './executeRecurringPurchase/executeRecurringPurchase.module';
import executeRedemption, * as executeRedemptionActions from './executeRedemption/executeRedemption.module';
import existingBanks, * as existingBankActions from './existingBanks/existingBanks.module';
import allFunds, * as allFundsActions from './funds/AllFunds/AllFunds.module';
import eligibleAgreements, * as eligibleAgreementsActions from './eligibleAgreements/eligibleAgreements.module';
import IRALimit, * as IRALimitActions from './funds/IRA/IRA.module';
import morningStarFunds, * as morningStarFundsActions from './funds/MorningStarFundFamily/MorningStarFundFamily.module';
import userFunds, * as userFundsActions from './funds/UserFunds/UserFunds.module';
import iraAutoMaxFunds, * as iraAutoMaxFundsActions from './funds/IRAAutoMaxFunds/IRAAutoMaxFunds.module';
import iraAutoMaxCartDetails, * as iraAutoMaxCartActions from './funds/IRAAutoMaxCartDetails/IRAAutoMaxCartDetails.module';
import iraAutoMaxCalculation, * as IRAAutoMaxCalculationActions from './funds/IRAAutoMaxCalculation/IRAAutoMaxCalculation.module';
import iraAutoMaxSubmission, * as IRAAutoMaxSubmissionActions from './funds/IRAAutoMaxSubmission/IRAAutoMaxSubmission.module';
import IRALimitsearch, * as IRALimitSearchActions from './funds/IRALimitSearch/IRALimitSearch.module';
import language, * as languageActions from './language/language.module';
import linkedBanks, * as linkedBankActions from './linkedBanks/linkedBanks.module';
import userManager, * as userManagerTypeActions from './manager/manager.module';
import marketVolatility, * as marketVolatilityActions from './marketVolatility/marketVolatility.module';
import modals, * as modalActions from './modals/modals.module';
import moneyMarketEvent, * as moneyMarketEventActions from './moneyMarketEvent/moneyMarketEvent.module';
import pendingTransactions, * as pendingTransactionsActions from './pendingTransactions/pendingTransactions.module';
import printConfirm, * as printConfirmActions from './printConfirm/printConfirm.module';
import userProductTypes, * as userProductTypeActions from './productTypes/productType.module';
import progress from './progress/progress.module';
import * as progressActions from './progress/actions';
import qcd, * as qcdActions from './qcd/qcd.module';
import quickBuy, * as quickBuyActions from './quickBuy/quickBuy.module';
import nasuAddedFunds, * as nasuAddedFundsActions from './nasuAddedFunds/nasuAddedFunds.module';
import quickSell, * as quickSellActions from './quickSell/quickSell.module';
import redeemThresholds, * as redeemThresholdsActions from './redeemThresholds/redeemThresholds.module';
import redirect, * as redirectActions from './redirect/redirect.module';
import RMDSetting, * as RMDSettingActions from './RMD/RMD.module';
import sellDeliveryMethod, * as sellDeliveryMethodActions from './sellDeliveryMethod/sellDeliveryMethod.module';
import sellEstimationDates, * as sellEstimationDatesActions from './sellEstimationDates/sellEstimationDates.module';
import sellTransaction, * as sellTransactionActions from './sellTransaction/sellTransaction.module';
import sellUncollectedShares, * as sellUncollectedSharesActions from './sellUncollectedShares/sellUncollectedShares.module';
import shoppingCart, * as shoppingCartActions from './shoppingCart/shoppingCart.module';
import stateWithholding, * as stateWithholdingActions from './stateWithholding/stateWithholding.module';
import transactionHistory, * as transactionHistoryActions from './transactionHistory/transactionHistory.module';
import transactionLimits, * as transactionLimitsActions from './transactionLimits/transactionLimits.module';
import { ModuleActions } from './types';
import browserSession from './user/BrowserSession/userBrowserSession.module';
import userCommunication, * as userCommunicationActions from './user/Communication/userCommunication.module';
import paperlessSetting, * as paperlessSettingActions from './user/Paperless/paperlessSetting.module';
import personalInformation, * as personalInformationActions from './user/PersonalInformation/PersonalInformation.module';
import userRegistrationTypeInfo, * as userRegistrationTypeInfoActions from './user/UserRegistrationTypes/UserRegistrationTypes.module';
import vanity from './vanity/vanity.module';
import rothConversionTransaction, * as rothConversionActions from './rothConversionTransaction/rothConversionTransaction.module';
import executeRothConversionTransaction, * as executeRothConversionActions from './executeRothConversion/executeRothConversion.module';
import beneficiaries, * as beneficiariesActions from './beneficiaries/beneficiaries.module';
import advisoryDetails, * as advisoryDetailsActions from './advisoryDetails/advisoryDetails.module';
import advisorHeadshot, * as advisorHeadshotActions from './advisorHeadshot/advisorHeadshot.module';
import advisors, * as advisorsActions from './advisors/advisors.module';
import deleteExistingRMD, * as deleteExistingRMDActions from './RMD/RMD.module';
import currentStep from './transferFunding/transferFunding.module';
import transferAccount from './transferFunding/continueStep/continue.module';
import fundingTrackingData from './fundingTrackingData/fundingTrackingData.module';

export default {
  allFunds,
  applicationData,
  authentication,
  automaticInvestments,
  automaticEdit,
  bankSelection,
  beneficiaries,
  bucketRoll,
  browserSession,
  chat,
  costBasis,
  editModeBank,
  eligibleAgreements,
  eVerification,
  exchangeTransaction,
  executeCollegeContribute,
  executeExchange,
  executePurchase,
  executeAutoExchange,
  executeRecurringPurchase,
  executeRedemption,
  existingBanks,
  IRALimit,
  IRALimitsearch,
  language,
  linkedBanks,
  modals,
  marketVolatility,
  moneyMarketEvent,
  morningStarFunds,
  paperlessSetting,
  pendingTransactions,
  personalInformation,
  printConfirm,
  progress,
  qcd,
  quickBuy,
  nasuAddedFunds,
  quickSell,
  autoExchange,
  RMDSetting,
  redeemThresholds,
  redirect,
  rothConversionTransaction,
  executeRothConversionTransaction,
  schools,
  isDistributeToSchool,
  schoolSelection,
  studentDetail,
  sellDeliveryMethod,
  sellEstimationDates,
  sellTransaction,
  sellUncollectedShares,
  stateWithholding,
  shoppingCart,
  transactionLimits,
  transactionHistory,
  userCommunication,
  userFunds,
  iraAutoMaxFunds,
  iraAutoMaxCartDetails,
  iraAutoMaxCalculation,
  iraAutoMaxSubmission,
  userManager,
  userProductTypes,
  userRegistrationTypeInfo,
  vanity,
  advisoryDetails,
  advisorHeadshot,
  advisors,
  deleteExistingRMD,
  currentStep,
  transferAccount,
  fundingTrackingData,
};

export const moduleActions: ModuleActions = {
  ...addSchoolActions,
  ...distributeToSchoolActions,
  ...schoolSelectionActions,
  ...studentDetailActions,
  ...allFundsActions,
  ...appDataActions,
  ...authenticationActions,
  ...automaticActions,
  ...automaticEditActions,
  ...bankSelectionActions,
  ...beneficiariesActions,
  ...bucketRollActions,
  ...chatActions,
  ...costBasisActions,
  ...editModeBankActions,
  ...eligibleAgreementsActions,
  ...eVerifyActions,
  ...exchangeTransactionActions,
  ...executeCollegeContributeActions,
  ...executeExchangeActions,
  ...executePurchaseActions,
  ...executeAutoExchangeActions,
  ...executeRecurringPurchaseActions,
  ...executeRedemptionActions,
  ...executeRothConversionActions,
  ...existingBankActions,
  ...IRALimitActions,
  ...IRALimitSearchActions,
  ...languageActions,
  ...linkedBankActions,
  ...marketVolatilityActions,
  ...modalActions,
  ...moneyMarketEventActions,
  ...morningStarFundsActions,
  ...paperlessSettingActions,
  ...pendingTransactionsActions,
  ...personalInformationActions,
  ...printConfirmActions,
  ...progressActions,
  ...qcdActions,
  ...quickBuyActions,
  ...nasuAddedFundsActions,
  ...quickSellActions,
  ...autoExchangeActions,
  ...redeemThresholdsActions,
  ...redirectActions,
  ...rothConversionActions,
  ...RMDSettingActions,
  ...sellDeliveryMethodActions,
  ...sellEstimationDatesActions,
  ...sellTransactionActions,
  ...sellUncollectedSharesActions,
  ...shoppingCartActions,
  ...stateWithholdingActions,
  ...transactionLimitsActions,
  ...transactionHistoryActions,
  ...userCommunicationActions,
  ...userFundsActions,
  ...iraAutoMaxFundsActions,
  ...iraAutoMaxCartActions,
  ...IRAAutoMaxCalculationActions,
  ...IRAAutoMaxSubmissionActions,
  ...userManagerTypeActions,
  ...userProductTypeActions,
  ...userRegistrationTypeInfoActions,
  ...advisoryDetailsActions,
  ...advisorHeadshotActions,
  ...advisorsActions,
  ...deleteExistingRMDActions,
};
